import React from "react";
import { scaleLinear, scaleOrdinal } from "d3-scale";
import { max } from "d3-array";
import { wordwrap } from "d3-jetpack";

const RemittanceCostChart = ({ props }) => {
  const width = props.width;
  const height = props.height;

  const margin = {
    top: 10,
    right: 10,
    bottom: 10,
    left: 30,
  };

  const w = width - margin.right - margin.left;
  const h = height - margin.top - margin.bottom;

  const data = props.data.remittanceCosts;

  const x = scaleOrdinal().domain([0, data.length]).range([0, w]);

  const y = scaleLinear().domain([0, 10]).range([h, 0]);

  const x2 = scaleLinear().domain([0, data.length]).range([20, w]);

  return (
    <div>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${400}`}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g className="y-axis">
            {y.ticks(10).map((d) => (
              <g key={`y-tick-${d}`} transform={`translate(0, ${y(d)})`}>
                <line
                  x1={x.range()[0]}
                  x2={x.range()[1]}
                  stroke={d === 0 ? "black" : "#ccc"}
                  style={{ strokeWidth: 0.5 }}
                />
                <text
                  dx={-5}
                  style={{
                    fontSize: "12px",
                    textAnchor: "end",
                    dominantBaseline: "central",
                  }}
                >
                  {d}%
                </text>
              </g>
            ))}
          </g>
          <rect
            y={y(3)}
            width={w}
            height={y(0) - y(3)}
            fill="green"
            opacity={0.1}
          />
          <text
            y={y(3)}
            dy={-3}
            x={x.range()[1]}
            fill="green"
            style={{ fontSize: 11, textAnchor: "end" }}
          >
            {props.sdgTarget}
          </text>
          <line
            x1={x.range()[0]}
            x2={x.range()[1]}
            y1={y(3)}
            y2={y(3)}
            stroke="green"
            style={{ strokeWidth: 2, strokeDasharray: "4 2" }}
          />
          {data
            .sort((a, b) => a["Q1 2020"] - b["Q1 2020"])
            .map((d, i) => (
              <g key={`item-${i}`} transform={`translate(${x2(i)}, 0)`}>
                <path
                  d={`M0,${y(d["Q1 2019"])} L${w / 10},${y(d["Q1 2019"])} L${
                    w / 10
                  },${y(d["Q1 2020"])}Z`}
                  fill={d["Q1 2019"] > d["Q1 2020"] ? "steelblue" : "orange"}
                  opacity={0.4}
                />
                <circle
                  r={1}
                  cy={y(d["Q1 2019"])}
                  fill={d["Q1 2019"] > d["Q1 2020"] ? "steelblue" : "orange"}
                />
                <circle
                  r={2}
                  cx={w / 10}
                  cy={y(d["Q1 2020"])}
                  fill={d["Q1 2019"] > d["Q1 2020"] ? "steelblue" : "orange"}
                />
                <text
                  x={w / 10 / 2}
                  y={(y(d["Q1 2019"]) + y(d["Q1 2020"])) / 2}
                  style={{
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    fontSize: 12,
                    fontWeight: "bold",
                  }}
                  dy={12}
                  fill={d["Q1 2019"] > d["Q1 2020"] ? "steelblue" : "orange"}
                >
                  {d["Q1 2019"] > d["Q1 2020"] ? "" : "+"}
                  {Math.round((d["Q1 2020"] - d["Q1 2019"]) * 10) / 10}{" "}
                  <tspan style={{ fontWeight: "normal", fontSize: 10 }}>
                    {props.pp}
                  </tspan>
                </text>
                {d.region !== "Global_average" ? (
                  ""
                ) : (
                  <g>
                    {[2019, 2020].map((year, k) => (
                      <text
                        key={`year-${year}`}
                        // y={y(d['Q1 2019'])}
                        // dy={-10}
                        // dx={w > 550 ? 0 : k === 0 ? 10 : -10}
                        style={{
                          textAnchor: "middle",
                          fontSize: 12,
                          dominantBaseline: "central",
                        }}
                      >
                        <tspan
                          x={year === 2020 ? w / 10 : 0}
                          style={{ fontSize: 9 }}
                          dy={-22}
                          y={y(d["Q1 2019"])}
                        >
                          {props.q1}
                        </tspan>
                        {""}
                        <tspan
                          x={year === 2020 ? w / 10 : 0}
                          dy={-10}
                          y={y(d["Q1 2019"])}
                          style={{ fontWeight: "bold" }}
                        >
                          {w < 550 ? `'${year - 2000}` : year}
                        </tspan>
                      </text>
                    ))}
                  </g>
                )}
                <line
                  x2={w / 10}
                  y1={y(d["Q1 2019"])}
                  y2={y(d["Q1 2020"])}
                  stroke={d["Q1 2019"] > d["Q1 2020"] ? "steelblue" : "orange"}
                  style={{ strokeWidth: 1 }}
                />

                {w < 550 && (
                  <text
                    style={{
                      fontSize: 12,
                      textAnchor: "middle",
                      dominantBaseline: "central",
                      fontWeight:
                        d.region === "Global_average" ? "bold" : "none",
                      fontStyle:
                        d.region === "Global_average" ? "italic" : "none",
                    }}
                    dy={i === 3 ? -80 : 0}
                    y={(80 + y(d["Q1 2019"]) + y(d["Q1 2020"])) / 2}
                    dx={w / 10 / 2}
                  >
                    {d.code}
                  </text>
                )}
                {w >= 550 && (
                  <text
                    style={{
                      fontSize: 12,
                      textAnchor: "middle",
                      dominantBaseline: "central",
                      fontWeight:
                        d.region === "Global_average" ? "bold" : "none",
                      fontStyle:
                        d.region === "Global_average" ? "italic" : "none",
                    }}
                    dy={i === 3 ? -80 : 0}
                  >
                    {wordwrap(
                      (
                        props.data.regions.find((p) => p.code === d.code) || {
                          label: props.globalAverage,
                        }
                      ).label,
                      d.region === "Global_average" ? 0 : 10
                    ).map((t, j) => (
                      <tspan
                        key={`t-${j}`}
                        dx={35}
                        x={0}
                        y={
                          (80 + y(d["Q1 2019"]) + y(d["Q1 2020"])) / 2 + j * 12
                        }
                      >
                        {t.replace("_", " ")}
                      </tspan>
                    ))}
                  </text>
                )}
              </g>
            ))}
        </g>
      </svg>
    </div>
  );
};

export default RemittanceCostChart;
